"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchingEngine = void 0;
const fetcher_1 = require("../fetcher");
const types_1 = require("../types");
const __1 = require("../");
class MatchingEngine {
    constructor(ctx, configId) {
        this.ctx = ctx;
        this.pda = new __1.PDA(ctx.program.programId, configId);
        this.escrowFetcher = new fetcher_1.EscrowFetcher(ctx.connection, this.pda);
        this.configId = configId;
    }
    getRandomOffer(fetcher, side, tokenAmount, bondType) {
        return __awaiter(this, void 0, void 0, function* () {
            const offersData = yield fetcher.getOffersByStatus(types_1.OfferState.Awaiting);
            const filterOfferDataWithAmount = offersData.filter((item) => item.availableAmount.gt(tokenAmount) &&
                JSON.stringify(item.side) === JSON.stringify(side) &&
                JSON.stringify(item.bondType) === JSON.stringify(bondType));
            if (!filterOfferDataWithAmount.length) {
                return null;
            }
            const randIndex = Math.floor(Math.random() * filterOfferDataWithAmount.length);
            return filterOfferDataWithAmount[randIndex];
        });
    }
    matchingTrade(user, tokenAmount, side, bondType) {
        return __awaiter(this, void 0, void 0, function* () {
            const randomOfferData = yield this.getRandomOffer(this.escrowFetcher, side, tokenAmount, bondType);
            if (!randomOfferData) {
                throw new Error("Can not find offer available amount");
            }
            let prependIxs = [];
            // Get offer client
            let offerClient = yield __1.OfferClient.getOffer(this.ctx, this.configId, randomOfferData.offerId);
            let { tx, id } = yield offerClient.requestCreateTrade(user, tokenAmount);
            return { tx, id: id, offerPubkey: randomOfferData.pubkey };
        });
    }
}
exports.MatchingEngine = MatchingEngine;
